import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  routes,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash'
})

export function resetRouter () {
  router.replace('/')
}

export default router
